import { kvGet, kvSet } from '../idb.js';
import { root, setNextId } from './seed.js';
import { filesystemState, getFsMap, resetFsMap, flattenTree } from './store.svelte.js';
import { virtualSearchNodes, buildVirtualSearchNodes, indexSearchNodes } from './search.js';
import { ensureSystemNodes } from './migrations.js';
import { touchFilesystem } from './mutations.js';
import { loadCloudFilesystem } from './cloud-fs.js';
import { isAdmin } from '../session.svelte.js';

const FILESYSTEM_KEY = 'virtual-filesystem-v1';

export const SCHEMA_VERSION = 2;

function getStoredSchemaVersion(saved) {
  return saved?._schemaVersion ?? 0;
}

export async function initializeFilesystem() {
  if (isAdmin()) {
    await loadCloudFilesystem();
    return;
  }
  try {
    const saved = await kvGet(FILESYSTEM_KEY);
    if (saved?.path === '/' && Array.isArray(saved.children)) {
      const storedVersion = getStoredSchemaVersion(saved);
      delete saved._schemaVersion;
      Object.assign(root, saved);
      resetFsMap(flattenTree(root));
      virtualSearchNodes.length = 0;
      virtualSearchNodes.push(...buildVirtualSearchNodes());
      indexSearchNodes();
      if (storedVersion < SCHEMA_VERSION) {
        ensureSystemNodes();
        root._schemaVersion = SCHEMA_VERSION;
        saveFilesystem();
      }
      const numericIds = [...getFsMap().values()]
        .map((node) => Number(String(node.id ?? '').replace('node-', '')))
        .filter(Number.isFinite);
      setNextId(Math.max(0, ...numericIds) + 1);
      touchFilesystem();
    } else {
      root._schemaVersion = SCHEMA_VERSION;
      await kvSet(FILESYSTEM_KEY, root);
    }
  } catch (error) {
    console.warn('[filesystem] Failed to restore virtual disk:', error);
  } finally {
    filesystemState.ready = true;
    filesystemState.revision += 1;
  }
}

export async function saveFilesystem() {
  if (isAdmin()) return;
  root._schemaVersion = SCHEMA_VERSION;
  await kvSet(FILESYSTEM_KEY, root);
}
